import { render, staticRenderFns } from "./personDetail.vue?vue&type=template&id=694d89a0&scoped=true"
import script from "./personDetail.vue?vue&type=script&lang=js"
export * from "./personDetail.vue?vue&type=script&lang=js"
import style0 from "./personDetail.vue?vue&type=style&index=0&id=694d89a0&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d89a0",
  null
  
)

export default component.exports